import { gql } from '@apollo/client'
import { PLANOGRAM_FRAGMENT } from '../fragments'

export const GET_ZONE_PLANOGRAMS = gql`
  query GetZonePlanograms($input: ZonePlanogramsInput) {
    zonePlanograms(input: $input) {
      results {
        ...Planogram
      }
      hasMore
      count
    }
  }
  ${PLANOGRAM_FRAGMENT}
`
